import { RouteErrorBoundary } from "src/components/ErrorBoundary/RouteErrorBoundary.tsx";

import { ModuleListV2 } from "src/framework/listV2/ModuleListV2.tsx";
import { Suspense } from "react";
import { queryClient } from "src/lib/react-query.tsx";
import { resourceListConfigQuery } from "src/system/resourceListConfigQuery.ts";
import { getClientConfig } from "src/client-config/getClientConfig.ts";
import { listTranslationsQuery } from "src/system/listTranslationsQuery.ts";

export type CreateModuleListV2Options = {
  resource: string;
};

export function createListV2({ resource }: CreateModuleListV2Options) {
  const Component = () => {
    return (
      // todo: loading state
      <Suspense fallback={""}>
        <ModuleListV2 resource={resource} />
      </Suspense>
    );
  };
  const loader = async () => {
    // prefetch list config
    const clientConfig = getClientConfig();

    if (!clientConfig) {
      return null;
    }
    // fetch in parallel
    await Promise.all([
      queryClient.ensureQueryData(
        resourceListConfigQuery({
          resource,
          clientConfig,
        }),
      ),
      queryClient.ensureQueryData(
        listTranslationsQuery({
          resource,
        }),
      ),
    ]);

    return null;
  };
  const ErrorBoundary = RouteErrorBoundary;
  return {
    Component,
    ErrorBoundary,
    loader,
  };
}
